import { ActionType } from "../actions/ActionTypes";
import { toast } from "react-toastify";

export interface StoryState {
  error: string;
  loading: boolean;
  generate_loading: boolean;
  lessonPlans: any[];
  message: string;
  generate_error: string;
  feedback_loading: boolean;
}

const initialState: StoryState = {
  error: "",
  loading: false,
  generate_loading: false,
  lessonPlans: [],
  message: "",
  feedback_loading: false,
  generate_error: "Hello",
};

const reducer = (state: StoryState = initialState, action: any): any => {
  switch (action.type) {
    case ActionType.GENERATE_LESSON_PLAN_INIT:
      return {
        ...state,
        generate_loading: true,
        error: "",
        generate_error: "",
        message: "",
      };
    case ActionType.GENERATE_LESSON_PLAN_SUCCESS:
      return {
        ...state,
        generate_loading: false,
        message: action.payload.message,
      };
    case ActionType.GENERATE_LESSON_PLAN_FAIL:
      toast.error(
        action.payload || "Error creating lesson plan, please try again later."
      );
      return {
        ...state,
        generate_loading: false,
        error: action.payload,
        generate_error: action.payload,
      };

    case ActionType.GET_ALL_LESSON_PLAN_INIT:
      return {
        ...state,
        error: "",
        loading: true,
      };

    case ActionType.GET_ALL_LESSON_PLAN_SUCCESS:
      return {
        ...state,
        error: "",
        loading: false,
        lessonPlans: action.payload,
      };

    case ActionType.GET_ALL_LESSON_PLAN_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        lessonPlans: [],
      };
    case ActionType.DELETE_LESSON_PLAN_INIT:
      return {
        ...state,
        error: "",
        loading: true,
      };

    case ActionType.DELETE_LESSON_PLAN_SUCCESS:
      return {
        ...state,
        error: "",
        loading: false,
      };

    case ActionType.DELETE_LESSON_PLAN_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case ActionType.LESSONPLAN_FEEDBACK_SUBMIT_INIT:
      return {
        ...state,
        feedback_loading: true,
        error: "",
        message: "",
      };
    case ActionType.LESSONPLAN_FEEDBACK_SUBMIT_SUCCESS:
      return {
        ...state,
        feedback_loading: false,
        message: action.payload.message || "Feedback submitted successfully",
      };
    case ActionType.LESSONPLAN_FEEDBACK_SUBMIT_FAIL:
      return {
        ...state,
        feedback_loading: false,
        error: action.payload,
        message: action.payload.message || "Error submitting feedback",
      };
    default:
      return state;
  }
};

export default reducer;
